<app-background-image
  [imageUrl]="imageUrl"
  [applyColoringToBg]="applyColoringToBg"
></app-background-image>
<router-outlet></router-outlet>
